<template>
  <div>
    <section class="forms component" resmed-component-name="product_review" v-bind:class="name"
              v-bind:style="{
               'background-image': `url(${acf.layout['background-image']})`,
               'background-color': acf.layout['background-color']
              }">
        <div class="container">
            <div class="row">
                <div class="col">
                    <component v-bind:is="active" v-bind:acf="acf"></component>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
    import forms from '../forms/index';
    import marketo from '../../mixins/marketo-form';

    export default {
        name: 'component-0b2c6190',
        mixins: [ marketo ],
        components: {
            ...forms
        },
        props: ['acf', 'name','origin'],
        created() {
            bus.$emit('navigation:reversed', true);
        },
        mounted() {
          this.get_marketo();
        },
        computed: {
            active() {
                const name = this.name.replace(/\s/, '-').toLowerCase();
                return `form-${name}`;
            }
        }
    }
</script>